import React from 'react';
import ParentSwitch from './ParentSwitch';

// Parent's switch for whether this child may spend the parent's wallet on songs. Off by default.
const WalletPurchasesToggle = ({ studentId, studentName }) => (
  <ParentSwitch
    studentId={studentId}
    field="allow_wallet_purchases"
    testId="wallet-purchases-toggle"
    title={`Let ${studentName} buy songs with my wallet`}
    help={`Off by default. When it is off, ${studentName} cannot spend your wallet balance; you can still buy songs for them yourself.`}
    onMessage={`${studentName} can now buy songs with your wallet`}
    offMessage={`${studentName} can no longer spend your wallet`}
  />
);

export default WalletPurchasesToggle;
